import * as React from "react";
import {useState} from "react";
import ActiveInsuranceCard from "InsuranceV2/ActiveInsurances/ActiveInsuranceCard";
import {RouteComponentProps} from "react-router-dom";
import ContainerBox from "myshubhlife-component/container-box";
import {getPreSignedUrl, downloadPdfFromPreSignedUrl} from "InsuranceV2/api";

export interface IActiveInsuranceList {
    distributorName: string;
    masterPolicyId: string;
    orderId: string;
    policyId: string;
    productName: string;
    status: string;
    userId: number;
    validityInMonths: number;
}

interface IProps {
    insuranceList: IActiveInsuranceList[];
}

const defaultErrorState = {index: null, msg: ""};

const ActiveInsurances = (props: RouteComponentProps & IProps) => {
    const [loading, setloading] = useState(false);
    const [error, setError] = useState<{index: null | number, msg: string}>(defaultErrorState);

    const handleDownloadInsurance = async (index: number) => {
        setloading(true);
        setError(defaultErrorState);
        try {
            const response = await getPreSignedUrl(props.insuranceList[index].orderId);
            await downloadPdfFromPreSignedUrl(response.preSignedUrl);
        } catch (e) {
            setError({index, msg: "Your policy not yet generated, mail us for more details"});
        }
        setloading(false);
    };

    return (
        <ContainerBox>
            {
                props.insuranceList.map((item, idx) => <ActiveInsuranceCard
                    key={idx}
                    product={item}
                    downloadHandler={() => handleDownloadInsurance(idx)}
                    errorMsg={error.msg}
                    showError={error.index === idx}
                    isloading={loading}
                />)
            }
        </ContainerBox>
    );
};

export default ActiveInsurances;
